<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 23"
    width="16"
    height="16"
    fill="#5f6368"
  ><path
    d="M0 0h24v24H0z"
    class="path-fill"
  /><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" /></svg>
</template>

<script>
export default {
  name: 'ContentCopyIcon',
};
</script>

<style scoped>
.path-fill {
  fill: #fff !important;
}
</style>
